import styled from '@emotion/styled';
import { buttonSize } from './mixins';

const TextContainer = styled('div')({
  marginLeft: '1.5rem',
  width: `calc(100% - (${buttonSize} + 1.5rem))`,
});

export default TextContainer;
